<div class="authorization-dialog" #printArea>
  <div class="dialog-header">
    <img
      src="assets/images/transend-logo-wide.svg"
      alt="Transend Logo"
      class="logo"
    />

    <span class="spacer"></span>

    <button
      mat-icon-button
      class="no-print"
      (click)="onPrint()"
      aria-label="Print"
    >
      <mat-icon>print</mat-icon>
    </button>

    <button
      mat-icon-button
      class="cancel-button no-print"
      (click)="onCancel()"
      aria-label="Close dialog"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <h1 class="dialog-title">Autopay Enrollment Authorization</h1>

    <p class="section-title">
      <strong>AutoPay Authorization Agreement</strong>
    </p>

    <p class="content-text">
      Your business may authorize Transend Financial to initiate AutoPay
      payments under your Credit Agreement (the "Agreement") by linking your
      Transend account to a designated checking or savings account ("AutoPay
      Account"). You may set up AutoPay through our online portal or by
      contacting our support team at 833-378-3841. This authorization is part of
      the Agreement. All terms not otherwise defined here shall have the meaning
      set forth in the Agreement.
    </p>

    <p class="section-title">
      <strong>Benefits of AutoPay for Your Business:</strong>
    </p>

    <ul class="content-list">
      <li>Ensure timely payments and avoid fees</li>
      <li>Streamline payment processes and reduce manual tasks</li>
      <li>Maintain good standing and uninterrupted access to credit</li>
    </ul>

    <p class="section-title">
      <strong>AutoPay Options and How It Works</strong>
    </p>

    <p class="content-text">
      Upon activating AutoPay, payments will be automatically initiated from
      your AutoPay Account on your billing due date.
    </p>

    <p class="section-title"><strong>Authorization Terms</strong></p>

    <p class="content-text">
      By enrolling, you represent and warrant that the AutoPay Account is a
      account used for commercial purposes under your company's (or individual)
      control and that you are authorized to permit withdrawals from it. You
      also confirm you are an authorized signer on the account provided You
      agree to promptly update Transend Financial with any changes to your
      AutoPay Account and authorize us to continue initiating payments from any
      replacement account you provide.
    </p>

    <p class="section-title">
      <strong>Important Notices Regarding AutoPay</strong>
    </p>

    <ul class="content-list">
      <li>
        Payments will be debited electronically via Automated Clearing House
        (ACH).
      </li>
      <li>
        This authorization will remain in effect until you cancel it, and you
        agree to notify Transend Financial in writing of any changes to your
        account information or to terminate this authorization at least 15
        business days prior to the next scheduled billing date.
      </li>
      <li>
        Payments are processed only on business days, which are Monday through
        Friday, excluding U.S. federal and banking holidays.
      </li>
      <li>
        If a scheduled payment date falls on a weekend or holiday, the payment
        will be processed on the next business day.
      </li>
      <li>
        ACH funds may be withdrawn as soon as the transaction is initiated. If
        an ACH debit is rejected due to insufficient funds, Transend Financial
        may charge a $29 returned payment fee.
      </li>
      <li>
        If the first scheduled payment fails, Transend Financial will not
        attempt additional automatic withdrawals. It is your responsibility to
        ensure sufficient funds are available.
      </li>
      <li>
        Payments may be subject to a 7-business day hold before they are fully
        settled. Your account credit limit may reflect the payment, but the
        actual availability of funds may be delayed until cleared.
      </li>
      <li>
        A record of this authorization will be maintained by Transend Financial
        and made available upon request.
      </li>
    </ul>

    <p class="section-title"><strong>Stopping or Disputing Payments</strong></p>

    <p class="content-text">
      You have the right to stop a scheduled AutoPay transaction. To do so:
    </p>

    <ul class="content-list">
      <li>
        Cancel online at least 3 business days before the scheduled payment date
      </li>
      <li>
        Call Transend Financial at 833-378-3841 at least 3 business days before
        the scheduled payment date. A written follow-up may be required within
        14 days of your call.
      </li>
    </ul>

    <p class="content-text">
      If you believe a payment was made in error, please contact us in writing
      per the dispute procedures outlined in your Credit Agreement.
    </p>
  </div>
</div>
